export default __webpack_public_path__ + "static/media/image-4.adf31d03.png";